import index from "./headerBarMailNotification.vue";
export default index;
